import LedgerPage from "@/components/LedgerPage";
export default function Expenses() { return <LedgerPage type="expense" />; }
